import { render, staticRenderFns } from "./DraggableDialog.vue?vue&type=template&id=0d492202&scoped=true&"
import script from "./DraggableDialog.vue?vue&type=script&lang=js&"
export * from "./DraggableDialog.vue?vue&type=script&lang=js&"
import style0 from "./DraggableDialog.vue?vue&type=style&index=0&id=0d492202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d492202",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VIcon})
